import {useContext} from 'react';
import {BrandInfoContext} from '@core-ui/brand-info-provider';

const useNewBrFont = () => {
  const {abbrBrand} = useContext(BrandInfoContext);

  return  abbrBrand === "br" || abbrBrand === "brfs";
};

export default useNewBrFont;
